import { DialogRef } from '@angular/cdk/dialog';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@shared/components/button';
import { ModalFooterDirective, ModalShellComponent } from '@shared/components/modal';
import { ToastService } from '@shared/toast';
import moment from 'moment';

import { DateRangePickerComponent } from '../../../../partage/components/date-range-picker/date-range-picker.component';
import { FichierSapForm } from '../fichier-sap.interface';
import { FichierSapService } from '../fichier-sap.service';

/**
 * Export du fichier SAP.
 *
 * L'ecran occupait auparavant une page entiere pour un seul selecteur de dates
 * et un bouton. Le contenu est identique, la validation des dates aussi ; seule
 * la presentation change.
 */
@Component({
  selector: 'app-dialog-fichier-sap',
  imports: [ReactiveFormsModule, ButtonComponent, DateRangePickerComponent, ModalShellComponent, ModalFooterDirective],
  templateUrl: './dialog-fichier-sap.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './dialog-fichier-sap.component.scss',
})
export class DialogFichierSapComponent {
  private readonly dialogRef = inject<DialogRef<boolean>>(DialogRef);
  private readonly fichierSapService = inject(FichierSapService);
  private readonly alertService = inject(ToastService);

  readonly fichierSapForm = new FormGroup<FichierSapForm>({
    filtreDateDebut: new FormControl<string>({ value: '', disabled: false }, { nonNullable: true }),
    filtreDateFin: new FormControl<string>({ value: '', disabled: false }, { nonNullable: true }),
  });

  protected fermer(): void {
    this.dialogRef.close(false);
  }

  /** Meme regle qu'avant : deux dates valides, la fin apres le debut. */
  private datesValides(): boolean {
    const debut = moment(this.fichierSapForm.controls.filtreDateDebut.value);
    const fin = moment(this.fichierSapForm.controls.filtreDateFin.value);
    if (!(debut.isValid() && fin.isValid() && fin >= debut)) {
      this.alertService.error('Les dates saisies sont incorrectes.', { durationMs: 10_000 });
      return false;
    }
    return true;
  }

  protected telechargerFichier(dateDebut: string, dateFin: string): void {
    if (!this.datesValides()) return;
    this.fichierSapService.telechargerFichier(dateDebut, dateFin);
    this.dialogRef.close(true);
  }
}
